import { render, staticRenderFns } from "./ChartAccountTable.vue?vue&type=template&id=71a6b0e2&scoped=true"
import script from "./ChartAccountTable.vue?vue&type=script&lang=js"
export * from "./ChartAccountTable.vue?vue&type=script&lang=js"
import style0 from "./ChartAccountTable.vue?vue&type=style&index=0&id=71a6b0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6b0e2",
  null
  
)

export default component.exports